// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"03bc697e","7175":"03bc697e","9836":"03bc697e"}[chunkId] + ".chunk.css";
};